// this is an autogenerated file from App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_TopBar_Order_Content_Content_OrderStatuses($order_id: uuid!) {
  timeline_events(
    where: {
      entity_id: { _eq: $order_id }
      entity_type: { _eq: ORDER }
      event_type: { _eq: ORDER_STATUS_CHANGED }
    }
    order_by: { created_at: desc }
  ) {
    id
    title: data(path: "title")
    status: data(path: "status")
    order_id: data(path: "orderId")
    product_name: data(path: "productName")
    tracking_id: data(path: "trackingId")
    tracking_url: data(path: "trackingUrl")
    carrier: data(path: "carrier")
    created_at
  }
}

`